import styled from "styled-components";

export const FooterArea = styled.div`
    height: 200px;
    display:flex;
    justify-content: center;
    flex-direction: column;
    align-items:center;
    text-align:center;
    font-size:14px;
    //border-top: solid 1px #6d6e8b;
`;